import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const servicesDetailsDialogStyle = (theme) => ({
	tableWrapper: {
		margin: '16px 58px 40px 58px',
		'& > div': {
			borderTopLeftRadius: '8px',
			borderTopRightRadius: '8px',
		},
		[theme.breakpoints.down('xs')]: {
			margin: '16px auto 40px auto',
			width: '90%',
		},
	},
	unsubscribe: {
		marginTop: '3px',
		display: 'block',
		'& span': {
			marginRight: '6px',
		},
	},
	arrowWrapper: {
		'& svg': {
			fill: blackColors[3],
		},
		cursor: 'pointer',
	},
});

export default servicesDetailsDialogStyle;
